//Styles
import "./styles/loader.css"

const Loader = ({ loading }) => {
    return (
        <div className="contLoader" style={{ display: loading ? "" : "none" }}>
            <span class="loader"></span>
        </div>
    )
}

export default Loader